export default {
  promotion: 'Aksiya',
  alifshopBanner: {
    title: 'Alif Shop’da onlayn xarid qiling',
    button: 'Alif Shop’ga o‘tish',
  },
  banner: {
    title: '{name}-da muddatli to‘lovga sotib oling',
    description:
      'O‘zbekiston bo‘ylab turli hamkorlarimizdan mahsulotlarni 24 oygacha muddatli to‘lovga sotib olishingiz mumkin',
    button: 'Qanday xarid qilaman?',
  },
  howToBuy: {
    title: 'Xarid qanday o‘tadi',
    items: [
      {
        title: 'Tovarni tanlang',
        description: 'Elektronikadan avtomahsulotlargacha',
      },
      {
        title: 'Rasmiylashtiring',
        description: 'Sotuvchiga pasport va kartani ko‘rsating',
      },
      {
        title: 'Tovarni oling',
        description: 'Ikki daqiqa ichida ko‘rib chiqamiz',
      },
    ],
    qr: {
      title: 'Agar QR bo‘lsa',
      description: 'Uni Alif ilovasi orqali skaner qiling va o‘zingiz 1 daqiqada rasmiylashtiring',
    },
  },
  nearestShops: {
    title: 'Eng yaqin do‘konlar',
    button: 'Barchasini ko‘rish',
    metresUnits: ['metr', 'metr', 'metr'],
    kilometresUnit: 'km',
    geolocationAllow: 'Yaqin-atrofdagi do‘konlarni ko‘rish uchun geolokatsiyangizga ruxsat bering',
  },
  filter: 'Filtr',
  monthsShort: 'oy',
};
